import Folder from "./folder";

export default class File {
    constructor() {
        this.id = null;
        this.name= null;
        this.type= null;
        this.size= null;
        this.status= true;
        this.hashKey= null;
        this.dtCreate= null;
        this.dtUpdate= null;
        this.folder = new Folder();
    }
}